import { render, staticRenderFns } from "./preTask.vue?vue&type=template&id=32b5c528&scoped=true&"
import script from "./preTask.vue?vue&type=script&lang=js&"
export * from "./preTask.vue?vue&type=script&lang=js&"
import style0 from "./preTask.vue?vue&type=style&index=0&id=32b5c528&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5c528",
  null
  
)

export default component.exports